module.exports = __webpack_public_path__ + "../resources/images/Applist-c6abf23220791881d28f47449135f454.svg";